import { createStore } from 'redux'
import rootReducer from './Reducers/RootReducer'
import { loadState, saveState } from "./localStorage";

const persistedState = loadState();

const store = createStore(rootReducer, persistedState)

store.subscribe(() => {
  saveState({
    europe: store.getState().europe,
    asia: store.getState().asia,
    america: store.getState().america,
  });
});

export default store;


